export default __webpack_public_path__ + "static/media/level-1.95a166b2.png";